import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {ProviderService} from "../provider-management/provider-management.service";
import { CommonUtility, Announcement, AnnouncementSummary,  VIEW_BTN, AgGridUtility } from '../shared';
import { DateUtility, ServerConstantsService, SINGLE_ROW_HEADER } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-announcements-summary',
  templateUrl: './announcements-summary.component.html',
  styleUrls: ['./announcements-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class AnnouncementsSummaryComponent implements OnInit {
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  announcements: Announcement[] = [];
  announcementSummary: AnnouncementSummary;
  serverConstants: any;
  userActionNotificationsMap: any;
  columnDefs: any;
  context: any;
  priorityJson: any;
  countiesJson: any;
  countiesMap: any;
  sharedData: any;
  gridApi;
  firstTime: Boolean = true;
  index:any;
  tabToNextCell:any;
  tabIndex:any = "-1";
  countyRefData: any;
  countyList: any = [];

  @ViewChild('header') header: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtility: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private providerService:ProviderService
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if(this.dataService.getSharedDataObject().get('ANCMT') == undefined){
      this.router.navigate(['/task']);
    }

  }
  ngOnInit() {
    this.countyRefData = this.data.getValueFromSharedDataMap('COUNTIES');
    let id = this.dataService.getSharedDataObject().get("providerId");
    this.providerService.getcountyDetails(id).subscribe((data) => {
      for (let i=0; i<data.length; i++) {
        for (let j=0; j<this.countyRefData.length; j++) {
          if (data[i].serviceCounty == this.countyRefData[j].value) {
            this.countyList.push(this.countyRefData[j]);
          }
        }
      }
    });

    /* set global values for page */
    this.index = this.dataService.getSharedDataObject().get("ANCMT").innerNavPages.find(x=> x.pageId === 'ANCSU');
    if(this.index.readOnly == true){
      this.tabIndex = "0";
    }
    this.sharedData = this.dataService.getSharedDataObject();

    /* Load Reference Tables*/
    this.data.currentMessage.subscribe(
      (message) => {

        this.parseRefTableData(message);
      });
    this.load();
    this.getColumnDefinitions();
  }




  load() {

    const countiesArr = this.dataService.getSharedDataObject().get("userCounties");
    const providerId = this.dataService.getSharedDataObject().get("providerId");
    let countiesStr;

    if(countiesArr !== undefined && countiesArr.length>0 ) {
      countiesArr.forEach(element => {
      if(element!==undefined && element.id!==undefined && element.id.serviceCounty !==undefined)
      {
        if(countiesStr===undefined)
        {
          countiesStr=element.id.serviceCounty;
        }else{
          countiesStr=countiesStr+","+element.id.serviceCounty;
        }
      }
     });
    }


    this.http.post<AnnouncementSummary>(this.serverConstants.SERVER_API_URL + '/announcements/provider/load', {"county":countiesStr,"provider":providerId}).subscribe(
      (data: AnnouncementSummary) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Announcement Summary', this.userActionNotificationsMap.ERROR);
        } else {

          if (data.wpAnnouncement.length > 0) {
            this.announcements = data.wpAnnouncement;
            this.announcements.forEach(row=>{

              if(row.counties!=="ALL" && row.counties!==null)
              {
                let replacedCounties="";
                const countyArray=row.counties.split(",");
                countyArray.forEach(county=>{
                  if(replacedCounties==="")
                  {
                    replacedCounties=this.countiesJson[county];
                  }else{
                    replacedCounties=replacedCounties+", "+this.countiesJson[county];
                  }

                });
                row.counties=replacedCounties;
              }
            })



          } else {
            this.announcements = [];

          }
        }
      }, response => {

        this.notificationService.error('CaseNotes Summary', this.userActionNotificationsMap.ERROR);
      }, () => {

      });
  }




  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Title',
        field: 'title',


      },
      {
        headerName: 'Effective  From',
        field: 'effectiveFromDt',
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.filterDates,
        }
        ,
      },
      {
        headerName: 'Effective To',
        field: 'effectiveToDt',
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.filterDates,
        }
        ,
      },

      {
        headerName: 'Priority',
        field: 'priorityCd',
        refData: this.priorityJson,
      }, {
        headerName: 'County',
        field: 'counties'


      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        width: 100,
        suppressFilter: true,
        suppressSorting: true
      },
    ];

    this.context = {
      component: this,
    };

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }
  getAnnouncementTitleLink(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    element.innerHTML = params.data.id;
    element.addEventListener('click', () => {
      if (params.data.counties !== undefined) {
        const county = params.data.counties.split();
        let arr1 = [];
        for (let i = 0; i<county.length; i++) {
          for (let j = 0; j < that.countyList.length; j++) {
            if (county[i] === that.countyList[j].name) {
              let arr = that.countyList[i].value;
              arr1.push(arr);
            }
          }
        }
        params.data.counties = arr1.toString();
      }
      that.dataService.addValueToSharedDataMap('announcement', params.data);
      that.router.navigate(['task/announcementsSummary/announcements']);
    });
    return element;
  }

  getEditButton(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    const image = VIEW_BTN;
    element.innerHTML = image;
    element.addEventListener('click', () => {
      if (params.data.counties !== undefined && params.data.counties !== null) {
        const county = params.data.counties.split(', ');
        let arr1 = [];
        for (let i = 0; i<county.length; i++) {
          for (let j = 0; j < that.countyList.length; j++) {
            if (county[i] === that.countyList[j].name) {
              let arr = that.countyList[j].value;
              arr1.push(arr);
            }
          }
        }
        params.data.counties = arr1.toString().split(',');
      }
      that.dataService.addValueToSharedDataMap('announcement', params.data);
      that.router.navigate(['task/announcementsSummary/announcements']);
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32){
        if (params.data.counties !== undefined) {
          const county = params.data.counties.split();
          let arr1 = [];
          for (let i = 0; i<county.length; i++) {
            for (let j = 0; j < that.countyList.length; j++) {
              if (county[i] === that.countyList[j].name) {
                let arr = that.countyList[i].value;
                arr1.push(arr);
              }
            }
          }
          params.data.counties = arr1.toString();
        }
        that.dataService.addValueToSharedDataMap('announcement', params.data);
        that.router.navigate(['task/announcementsSummary/announcements']);
      }
    });
    element.setAttribute("tabindex", "0");
    return element;

  }


  formatDates(params) {
    if (!params.value) {
      return null;
    }
    const dateParts = params.value.split('/');
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    const dayParts = (String(day)).split(" ");
    return month + '/' + dayParts[0] + '/' + year;
  }

  filterDates(filterLocalDateAtMidnight, cellValue) {
    if (!cellValue) {
      return;
    }
    const dateParts = cellValue.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridApi.columnDefs = this.columnDefs;
    }
    else{
      this.gridApi.sizeColumnsToFit();
    }
  }

  loadAnnouncementDetails() {
    this.router.navigate(['task/announcementsSummary/announcements']);
    this.dataService.removeValueFromSharedDataMap('announcement');
  }
  parseRefTableData(myData) {
    if (myData !== undefined && myData.englishDropDown) {

      const priorityArray = myData.englishDropDown["PRIORITY"];

      this.priorityJson = this.commonUtil.createNativeMapFromList(priorityArray);

      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);


      const countyArray = myData.englishDropDown["COUNTIES"];
      this.countiesMap = this.commonUtil.createMapFromList(countyArray);
      this.countiesJson = this.commonUtil.createNativeMapFromList(countyArray);
    }
  }

  focusSummary(event) {
    this.firstTime = false;
    this.addEventListenerToSearch(event);
  }

  addEventListenerToSearch(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }
    if(this.announcements.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusing(event){
    if(!event.shiftKey && event.keyCode === 9){
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }
  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/announcements-summary/announcements-summary.component.ts